import { SESSION_STORAGE_SHOW_NOTIFY_ME_WARNING_KEY } from "./constants";

export const storeNotifyMeWarningForSession = () => {
  try {
    sessionStorage.setItem(SESSION_STORAGE_SHOW_NOTIFY_ME_WARNING_KEY, true);
    // eslint-disable-next-line no-empty
  } catch (_) {}
};
